import { InviteService } from "@/services/InviteService";
import { InviteGameDetail } from '@/_models/Game';

export class InviteUtils{
  async validateGameInvitation (gameId:string):Promise<boolean> {
    const invite = new InviteService();
    const isValid = await invite.checkInvitation(gameId);
    return isValid;
  }

  async fetchInvitedGames():Promise<InviteGameDetail[]>{
    const invite = new InviteService();
    const games = await invite.fetchInvitation();
    return games;
  }
}